import React from 'react';
import * as e from '../elements';

export default {
  name: 'Cover Image Right',
  description: 'Product photo or screenshot on the right',
  thumb: 'cover-image-right',
  tags: ['Cover'],
  jsx: (
    <e.PBlock
      height="content"
      pad="md"
    >
      <div className="row align-items-center">
        <div className="col-12 text-center col-md-6 text-md-right my-3">
          <e.PText
            color="primary"
            text="Product Name"
            size="header-h2"
            className="my-3"
          />
          <e.PText
            color="black-lo"
            text="One-liner slogan"
            size="subheader-md"
            className="my-3"
          />
          <e.PText
            color="black-md"
            text="A brief overview of the product. What is it? How can it help your customers? Why would they care about it? And how it is better than other products out there?"
            size="text-md"
            className="my-3"
          />
        </div>
        <div className="col-12 order-2 text-center col-md-6 order-md-1 my-3">
          <e.PImage
            src="https://lh3.googleusercontent.com/JNvGHXHXN-j56P6DFHQTKgsc8O42Kczq74Fjd_gESXKgQzXoRHwT3p7Sn9iKElMYhM2ODkXxvioCb_lUQaWukp0"
            renderSize="720"
          />
        </div>
      </div>
    </e.PBlock>
  ),
};



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/CoverImageRight.jsx